import { Record, List, fromJS } from 'immutable';
import CurrencyUtilities from 'records/CurrencyUtilities';

const defaultValues = {
  id: null,
  recipes: new List(),
  cost: 0,
  price: 0,
};

export default class MenuItemCost extends Record(defaultValues, MenuItemCost) {
  constructor(values) {
    super({
      ...values,
      recipes: values && values.recipes ? fromJS(values.recipes) : defaultValues.recipes,
      cost: values && values.cost
            ? CurrencyUtilities.currencyFormat(values.cost) : defaultValues.cost,
    });
  }

  addRecipe(id) {
    return this.get('recipes').push(id);
  }

  removeRecipe(id) {
    const index = this.findRecipeIndexById(id);
    return this.get('recipes').delete(index);
  }

  findRecipeIndexById(id) {
    const recipes = this.get('recipes');
    return recipes.findIndex(recipeId => {
      return recipeId === id ? recipeId : undefined;
    });
  }
}
